import { render, staticRenderFns } from "./carParkBaseInfo.vue?vue&type=template&id=2617fb9c&scoped=true&"
import script from "./carParkBaseInfo.vue?vue&type=script&lang=js&"
export * from "./carParkBaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./carParkBaseInfo.vue?vue&type=style&index=0&id=2617fb9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2617fb9c",
  null
  
)

export default component.exports